module.exports = __webpack_public_path__ + "img/toyad.1ff9cf12.jpg";